// extracted by mini-css-extract-plugin
module.exports =  {"root":"amkVSCNBujgSxFEozVug"};